import { useEffect, useState } from "react";
import { Header, Loading, Toast } from "../components";
import {
  Ambiente,
  Contingencia,
  DataBr,
  FormaPagto,
  HoraBr,
  MoedaBr,
  Bandeira,
  Status,
  Rodoviaria,
  Porcento
} from "../components/Formatar";
import Axios from "axios";
import { Row, Col } from "react-bootstrap";

const RelatorioBilhetes = () => {
  const params = new URLSearchParams(window.location.search);

  const [data, setData] = useState(params.get("data") || "dhVenda");
  const [inicio, setInicio] = useState(params.get("inicio") || "");
  const [fim, setFim] = useState(params.get("fim") || "");
  const [hora, setHora] = useState(params.get("hora") || "todas");
  const [serie, setSerie] = useState(params.get("serie") || "todas");
  const [linha, setLinha] = useState(params.get("linha") || "todas");
  const [origem, setOrigem] = useState(params.get("origem") || "todas");
  const [pagto, setPagto] = useState(params.get("pagto") || "todas");
  const [portais, setPortais] = useState(params.get("portais") || "todas");
  const [status, setStatus] = useState(params.get("status") || "todas");

  const [dados, setDados] = useState([]);
  const [total, setTotal] = useState({});
  const [toast, setToast] = useState(false);
  const [loading, setLoading] = useState(false);

  let calculo = {
    passagem: 0,
    cancelada: 0,
    dinheiro: 0,
    credito: 0,
    debito: 0,
    vale: 0,
    pix: 0,
    portais: 0,
    outros: 0,
    tarifa: 0,
    seguro: 0,
    taxa: 0,
    svi: 0,
  };

  const GetDados = () => {
    if (inicio && fim) {
      setLoading(true);

      const url = `http://187.86.158.45:3010/api/bilhetes/relatorio/${data}/${inicio}/${fim}/${hora}/${serie}/${linha}/${origem}/${pagto}/${status}/${portais}`;

      console.log(url);

      Axios.get(url).then((res) => {
        setDados(res.data);
        setToast(true);

        res.data.forEach((doc) => {
          if (doc.status) {
            calculo.dinheiro -= doc.valorDinheiro || 0;
            calculo.credito -= doc.valorCredito || 0;
            calculo.debito -= doc.valorDebito || 0;
            calculo.vale -= doc.valorVale || 0;
            calculo.pix -= doc.valorPix || 0;
            calculo.outros -= doc.valorOutros || 0;
            calculo.portais -= doc.portais || 0;
            calculo.cancelada += doc.valorLiquido || 0;
            calculo.tarifa -= doc.tarifa || 0;
            calculo.seguro -= doc.seguro || 0;
            calculo.taxa -= doc.tmr || 0;
            calculo.svi -= doc.svi || 0;
          } else {
            calculo.dinheiro += doc.valorDinheiro || 0;
            calculo.credito += doc.valorCredito || 0;
            calculo.debito += doc.valorDebito || 0;
            calculo.vale += doc.valorVale || 0;
            calculo.pix += doc.valorPix || 0;
            calculo.portais += doc.portais || 0;
            calculo.outros += doc.valorOutros || 0;
            calculo.passagem += doc.valorLiquido || 0;
            calculo.tarifa += doc.tarifa || 0;
            calculo.seguro += doc.seguro || 0;
            calculo.taxa += doc.tmr || 0;
            calculo.svi += doc.svi || 0;
          }
        });

        setTotal(calculo);
        setLoading(false);
      });
    }
  };

  const HandleSubmit = (e) => {
    e.preventDefault();

    const url = `/relatorioBilhetes/?data=${data}&inicio=${inicio}&fim=${fim}&hora=${hora}&serie=${serie}&linha=${linha}&origem=${origem}&pagto=${pagto}&status=${status}&portais=${portais}`;

    window.location.href = url;
  };

  useEffect(() => {
    GetDados();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header />

      {!loading && (
        <div className="container">
          <div className="d-flex justify-content-center my-4">
            <div className="col-sm-12">
              <form onSubmit={HandleSubmit}>
                <h5 className="text-center">Relatório de Bilhetes</h5>
                <Row className="mt-3">
                  <Col className="col">
                    <label htmlFor="data" className="form-label">
                      Tipo de Data
                    </label>
                    <select
                      className="form-select"
                      aria-label="data"
                      value={data}
                      onChange={(e) => setData(e.target.value)}
                    >
                      <option value="dhVenda">Venda</option>
                      <option value="dhViagem">Viagem</option>
                      <option value="dhAberta">Checkin</option>
                    </select>
                  </Col>
                  <Col>
                    <label htmlFor="inicio" className="form-label">
                      Data Inicial
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      id="inicio"
                      value={inicio}
                      onChange={(e) => setInicio(e.target.value)}
                      required
                    />
                  </Col>
                  <Col>
                    <label htmlFor="fim" className="form-label">
                      Data Final
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      id="fim"
                      value={fim}
                      onChange={(e) => setFim(e.target.value)}
                      required
                    />
                  </Col>
                  <Col>
                    <label htmlFor="hora" className="form-label">
                      Hora Viagem
                    </label>
                    <input
                      className="form-control"
                      type="time"
                      id="hora"
                      value={hora}
                      onChange={(e) => setHora(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <label htmlFor="serie" className="form-label">
                      Emissor
                    </label>
                    <select
                      className="form-select"
                      aria-label="serie"
                      value={serie}
                      onChange={(e) => setSerie(e.target.value)}
                    >
                      <option value="todas">Todas</option>
                      <option value="116">Pelotas</option>
                      <option value="401">Porto Alegre</option>
                      <option value="122">Rio Grande</option>
                      <option value="21">Canguçu</option>
                      <option value="237">Piratini</option>
                      <option value="252">Santa Vitória</option>
                      <option value="74">Chui</option>
                      <option value="503">Quinta</option>
                      <option value="172">Pedro Osório</option>
                      <option value="91">Jaguarão</option>
                      <option value="114">Pinheiro Machado</option>
                      <option value="271A">Cassino</option>
                      <option value="900">Estrada</option>
                    </select>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <label htmlFor="linha" className="form-label">
                      Linha
                    </label>
                    <select
                      className="form-select"
                      aria-label="linha"
                      value={linha}
                      onChange={(e) => setLinha(e.target.value)}
                    >
                      <option value="todas">Todas</option>
                      <option value="353">Pelotas x Porto Alegre</option>
                      <option value="271">Pelotas x Rio Grande</option>
                      <option value="20">
                        Pelotas x Rio Grande (S. Porto)
                      </option>
                      <option value="622">Pelotas x Canguçu</option>
                      <option value="259">
                        Pelotas x Canguçu (M. Redondo)
                      </option>
                      <option value="269">Pelotas x Piratini</option>
                      <option value="261">Pelotas x Chui</option>
                      <option value="271A">Pelotas x Cassino</option>
                      <option value="408">Rio Grande x Chui</option>
                      <option value="1636">Canguçu x Porto Alegre</option>
                      <option value="2760">Canguçu x Piratini</option>
                    </select>
                  </Col>
                  <Col>
                    <label htmlFor="origem" className="form-label">
                      Origem
                    </label>
                    <select
                      className="form-select"
                      aria-label="origem"
                      value={origem}
                      onChange={(e) => setOrigem(e.target.value)}
                    >
                      <option value="todas">Todas</option>
                      <option value="Pelotas">Pelotas</option>
                      <option value="Porto Alegre">Porto Alegre</option>
                      <option value="Rio Grande">Rio Grande</option>
                      <option value="Canguçu">Canguçu</option>
                      <option value="Piratini">Piratini</option>
                      <option value="Santa Vitoria do Palmar">
                        Santa Vitória
                      </option>
                      <option value="Chui">Chui</option>

                      <option value="Quinta">Quinta</option>
                      <option value="Pedro Osorio">Pedro Osório</option>
                      <option value="271A">Cassino</option>
                    </select>
                  </Col>
                  <Col>
                    <label htmlFor="pagto" className="form-label">
                      Forma de Pagamento
                    </label>
                    <select
                      className="form-select"
                      aria-label="pagto"
                      value={pagto}
                      onChange={(e) => setPagto(e.target.value)}
                    >
                      <option value="todas">Todas</option>
                      <option value="01">Dinheiro</option>
                      <option value="02">Cheque</option>
                      <option value="03">Crédito</option>
                      <option value="04">Débito</option>
                      <option value="05">Vale</option>
                      <option value="06">Pix</option>
                      <option value="99">Outros</option>
                    </select>
                  </Col>
                  <Col>
                    <label htmlFor="portais" className="form-label">
                      Portais
                    </label>
                    <select
                      className="form-select"
                      aria-label="portais"
                      value={portais}
                      onChange={(e) => setPortais(e.target.value)}
                    >
                      <option value="todas">Todos</option>
                      <option value="1">Somente Blablacar</option>
                      <option value="2">Somente WhatsApp </option>
                    </select>
                  </Col>
                  <Col>
                    <label htmlFor="status" className="form-label">
                      Status
                    </label>
                    <select
                      className="form-select"
                      aria-label="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="todas">Todas</option>
                      <option value="N">Normal</option>
                      <option value="C">Cancelada</option>
                      <option value="R">Revalidada</option>
                      <option value="E">Embarcada</option>
                      <option value="NE">Não Embarcada</option>
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <label htmlFor="submit" className="form-label text-white">
                      -
                    </label>
                    <button className="btn btn-primary col-sm-12" type="submit">
                      Consultar
                    </button>
                  </Col>
                </Row>
              </form>
              {toast && <Bilhete dados={dados} total={total} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const InfoItem = ({ label, value }) => (
  <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-1">
    <div className="text-muted small lh-1">{label}</div>
    <div className="fw-semibold small text-truncate">{value || "-"}</div>
  </div>
);

const Bilhete = (props) => {
  const dados = props.dados;

  const GetMsg = () => {
    if (dados.length === 0) return "Nenhum bilhete encontrado";
    else if (dados.length === 1) return "1 bilhete encontrado";
    else return `${dados.length} bilhetes encontrados`;
  };

  const msg = GetMsg();

  return (
    <>
      <div className="mt-5 p-3 text-center">
        <table className="table table-bordered table-sm">
          <thead className="table-light">
            <tr>
              <th className="col-sm-2">Dinheiro</th>
              <th className="col-sm-2">Crédito</th>
              <th className="col-sm-2">Débito</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{MoedaBr(props.total.dinheiro)}</td>
              <td>{MoedaBr(props.total.credito)}</td>
              <td>{MoedaBr(props.total.debito)}</td>
            </tr>
          </tbody>
          <thead className="table-light">
            <tr>
              <th className="col-sm-2">Pix</th>
              <th className="col-sm-2">Vale</th>
              <th className="col-sm-2">Outros</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{MoedaBr(props.total.pix)}</td>
              <td>{MoedaBr(props.total.vale)}</td>
              <td>{MoedaBr(props.total.outros)}</td>
            </tr>
          </tbody>
          <thead className="table-light">
            <tr>
              <th className="col-sm-2">Total Tarifa</th>
              <th className="col-sm-2">Total Seguro</th>
              <th className="col-sm-2">Total Taxa</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{MoedaBr(props.total.tarifa)}</td>
              <td>{MoedaBr(props.total.seguro)}</td>
              <td>{MoedaBr(props.total.taxa)}</td>
            </tr>
          </tbody>
          <thead className="table-light">
            <tr>
              <th className="col-sm-2">Total Vendido</th>
              <th className="col-sm-2">Total Cancelado</th>
              <th className="col-sm-2">Total Geral</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{MoedaBr(props.total.passagem)}</td>
              <td>{MoedaBr(props.total.cancelada)}</td>
              <td>{MoedaBr(props.total.passagem - props.total.cancelada)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {dados.length < 1000 &&
        dados.map((bpe) => (
          <div className="my-5 px-2 py-3 text-center border small rounded text-capitalize">
            <div className="row mb-2">
              <div className="text-muted small lh-1">Chave</div>
              <div className="fw-semibold small text-truncate">
                <a
                  href={`https://dfe-portal.svrs.rs.gov.br/bpe/qrCode?chBPe=${bpe.chave}&tpAmb=1`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {bpe.chave}
                </a>
              </div>
            </div>
            <hr />
            <div className="row mb-2">
              <InfoItem label="Bilhete" value={bpe.bilhete} />
              <InfoItem label="Série" value={bpe.serie} />
              <InfoItem label="Origem" value={bpe.origem} />
              <InfoItem label="Destino" value={bpe.destino} />
              <InfoItem label="Poltrona" value={bpe.poltrona} />
              <InfoItem label="Box" value={bpe.plataforma} />
            </div>
            <div className="row mb-2">
              <InfoItem label="Descrição" value={bpe.descricaoPassagem} />
              <InfoItem label="Linha" value={bpe.linha} />
              <InfoItem label="Passageiro" value={bpe.nomeCliente} />
              <InfoItem label="Documento" value={bpe.docCliente} />
              <InfoItem label="Data Viagem" value={DataBr(bpe.dhViagem)} />
              <InfoItem label="Hora Viagem" value={HoraBr(bpe.dhViagem)} />
            </div>

            <div className="row mb-2">
              <InfoItem label="Emissor" value={Rodoviaria(bpe.serie)} />
              <InfoItem label="Operador" value={Rodoviaria(bpe.operador)} />
              <InfoItem label="Ambiente" value={Ambiente(bpe.ambiente)} />
              <InfoItem
                label="Contingência"
                value={Contingencia(bpe.emissao)}
              />
              <InfoItem label="Data Venda" value={DataBr(bpe.dhVenda)} />
              <InfoItem label="Hora Venda" value={HoraBr(bpe.dhVenda)} />
            </div>

            <hr />

            <div className="row mb-2">
              <InfoItem
                label="Forma"
                value={bpe?.descricaoPagto || FormaPagto(bpe?.formaPagto)}
              />
              <InfoItem label="Documento" value={bpe.documentoPagto} />
              <InfoItem label="Tipo Desconto" value={bpe.tipoDesconto} />
              <InfoItem label="Bandeira" value={Bandeira(bpe.bandeira)} />
              <InfoItem label="Autorização" value={bpe.autorizacao} />
              <InfoItem label="NSU" value={bpe.nsu} />
            </div>

            <div className="row mb-2">
              <InfoItem label="Tarifa" value={MoedaBr(bpe.tarifa)} />
              <InfoItem label="Seguro" value={MoedaBr(bpe.seguro)} />
              <InfoItem label="Taxa" value={MoedaBr(bpe.tmr)} />
              <InfoItem label="SVI" value={MoedaBr(bpe.svi)} />
              <InfoItem label="Desconto" value={MoedaBr(bpe.valorDesconto)} />
              <InfoItem label="Total" value={MoedaBr(bpe.valorLiquido)} />
            </div>

            <div className="row mb-2">
              <InfoItem label="Dinheiro" value={MoedaBr(bpe.valorDinheiro)} />
              <InfoItem label="Crédito" value={MoedaBr(bpe.valorCredito)} />
              <InfoItem label="Débito" value={MoedaBr(bpe.valorDebito)} />
              <InfoItem label="Vale" value={MoedaBr(bpe.valorVale)} />
              <InfoItem label="Pix" value={MoedaBr(bpe.valorPix)} />
              <InfoItem label="Outros" value={MoedaBr(bpe.valorOutros)} />
            </div>

            <hr />
            <div className="row mb-2">
              <InfoItem label="CST" value={bpe.icmsCst} />
              <InfoItem
                label="Redução Base"
                value={Porcento(bpe.icmsReducaoBC)}
              />
              <InfoItem label="Base Cálculo" value={MoedaBr(bpe.icmsBC)} />
              <InfoItem label="Alíquota" value={Porcento(bpe.icmsAliquota)} />
              <InfoItem
                label="Crédito Outorgado"
                value={MoedaBr(bpe.icmsCredito)}
              />
              <InfoItem label="Valor ICMS" value={MoedaBr(bpe.icmsValor)} />
            </div>

            <hr />

            <div className="row mb-2">
              <InfoItem
                label="Embarcada"
                value={bpe.dhCheckin ? "Sim" : "Não"}
              />
              <InfoItem label="Dispositivo" value={bpe.imei} />
              <InfoItem label="Data Aberta" value={DataBr(bpe.dhAberta)} />
              <InfoItem label="Hora Aberta" value={HoraBr(bpe.dhAberta)} />
              <InfoItem label="Data Embarque" value={DataBr(bpe.dhCheckin)} />
              <InfoItem label="Hora Embarque" value={HoraBr(bpe.dhCheckin)} />
            </div>

            <hr />

            <div className="row mb-2">
              <InfoItem
                label="Status"
                value={(bpe.chaveNova && "Remarcado") || Status(bpe.status)}
              />
              <InfoItem
                label="Bpe Original"
                value={
                  bpe.chaveAntiga && (
                    <a
                      href={`http://192.168.0.117:3003/consultaBilhetes?tipo=chave&valor=${bpe.chaveAntiga}`}
                    >
                      Abrir
                    </a>
                  )
                }
              />
              <InfoItem
                label="BPe Remarcado"
                value={
                  bpe.chaveNova && (
                    <a
                      href={`http://192.168.0.117:3003/consultaBilhetes?tipo=chave&valor=${bpe.chaveNova}`}
                    >
                      Abrir
                    </a>
                  )
                }
              />
              <InfoItem label="Data Status" value={DataBr(bpe.dhEvento)} />
              <InfoItem label="Hora Status" value={HoraBr(bpe.dhEvento)} />
              <InfoItem label="Protocolo" value={bpe.protocolo} />
            </div>
          </div>
        ))}

      <Toast header={msg} />
    </>
  );
};

export default RelatorioBilhetes;
